import styled from "styled-components";
import { palette } from "../../styles/palette";

export const NotFoundContainer = styled.div`
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(
    135deg,
    ${palette.greenSecond} 0%,
    ${palette.white} 100%
  );
  padding: 20px;
`;

export const NotFoundContent = styled.div`
  text-align: center;
  max-width: 500px;
  padding: 40px;
  background: ${palette.white};
  border-radius: 8px;
  box-shadow: 0 10px 30px ${palette.shadowLight};
`;

export const NotFoundIcon = styled.div`
  margin-bottom: 24px;
  color: ${palette.grenTitle};
  opacity: 0.8;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const NotFoundTitle = styled.h1`
  font-size: 72px;
  font-weight: 700;
  color: ${palette.grenTitle};
  margin: 0 0 16px 0;
  line-height: 1;
`;

export const NotFoundSubtitle = styled.h2`
  font-size: 28px;
  font-weight: 600;
  color: ${palette.textGreenTitle};
  margin: 0 0 16px 0;
`;

export const NotFoundDescription = styled.p`
  font-size: 16px;
  color: ${palette.secondaryTextColor};
  margin: 0 0 32px 0;
  line-height: 1.6;
`;

export const NotFoundButton = styled.button`
  background: ${palette.orange};
  color: ${palette.white};
  border: none;
  border-radius: 8px;
  padding: 14px 32px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px ${palette.shadowMedium};

  &:hover {
    background: ${palette.orangeTwo};
    transform: translateY(-2px);
    box-shadow: 0 6px 16px ${palette.shadowDark};
  }

  &:active {
    transform: translateY(0);
  }
`;
